import { fileToBase64 } from '../../../../../../_metronic/helpers';
import { api } from '../../../../../modules/api/api';
import { useAuth } from '../../../../../modules/auth';
import { SiService } from '../../../mappings';

export const useSaveCapture = () => {
  const { currentUser, auth, refresh } = useAuth();

  /**
   * Returns the capture_id if the screenshot was saved successfully, undefined otherwise.
   */
  const saveCapture = async (data: {
    file: File;
    requestId: string;
    queueId: string;
    url: string;
    service?: SiService;
    vpn?: string;
    brand?: string;
    imageUrl?: string;
  }): Promise<string> => {
    if (!data.requestId && !data.queueId) return undefined;

    try {
      const payload = {
        request_id: data.requestId,
        queue_id: data.queueId,
        image_string: await fileToBase64(data.file),
        url: data.url,
        service: data.service,
        vpn: data?.vpn || '',
        brand: data?.brand || '',
        image_url: data?.imageUrl || '',
      };

      const { result, status } = await api(
        `admin/v1/save_capture`,
        {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload),
        },
        { token: auth?.accessToken, refresh },
        'site-intelligence',
      ).then(async (resp) => {
        const result = await resp?.json();
        return { result: result, status: result?.code ?? resp?.status };
      });
      const resolvedResult = await result;
      if (status === 200 && resolvedResult.code === 200 && resolvedResult.error === false) {
        return resolvedResult.results.capture_id;
      } else {
        return undefined;
      }
    } catch (err) {
      return undefined;
    }
  };

  return { saveCapture };
};
